(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["conversion-bundle"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('.conversion-bundle').forEach((section) => {
    const select = section.querySelector('[data-variant-select]');
    const input = section.querySelector('[data-variant-input]');
    const price = section.querySelector('[data-price]');
    const compare = section.querySelector('[data-compare]');
    const badge = section.querySelector('[data-promo-badge]');
    const image = section.querySelector('[data-variant-media] img');
    if (!select || !input || !price) return;
    select.addEventListener('change', () => {
      const option = select.options[select.selectedIndex];
      input.value = option.value;
      price.textContent = option.dataset.price;
      if (compare && badge) {
        const has = Boolean(option.dataset.compare);
        compare.textContent = option.dataset.compare || '';
        compare.hidden = !has;
        badge.hidden = !has;
      }
      if (image && option.dataset.imageSrc) {
        image.src = option.dataset.imageSrc;
        image.srcset = option.dataset.imageSrcset || '';
        image.width = option.dataset.imageWidth || image.width;
        image.height = option.dataset.imageHeight || image.height;
        image.alt = option.dataset.imageAlt || image.alt;
      }
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
